const localConfig={
    baseUrl: 'https://profil.bayerischerbauernverband.de',
    baseBbvUrl: 'https://www.bayerischerbauernverband.de',
    anmeldungBaseUrl: 'https://profil.bayerischerbauernverband.de/services/veranstaltung/',
};
export default localConfig



// WEBPACK FOOTER //
// ./src/local.config.js